import React from 'react';
import { Tab, Tabs } from '@material-ui/core';
import classNames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import _ from 'lodash';

import './PaymentTabs.scss';
import ToolTip from 'src/components/ToolTip/ToolTip';

interface PaymentTabsProps {
  selectedTab: number,
  // eslint-disable-next-line no-unused-vars
  onChange: (e, v) => void,
  tabs: {
    title: string,
    description?: string,
    id: string
  }[]
}

function PaymentTabs({ selectedTab, onChange, tabs }: PaymentTabsProps) {
  const { t } = useTranslation();

  return (
    <Tabs
      className="payment-tabs__tab-container"
      value={ selectedTab }
      onChange={ onChange  }
      TabIndicatorProps={ { style: { display:'none' } } }
    >
      {
        _.map(tabs, (tab, index) => (
          <Tab
            key={ tab.id }
            label={
              <ToolTip
                title={ t(`${ tab.title }`) }
                formattedMessage={
                  <Trans i18nKey={ tab.description }>
                    <p />
                  </Trans>
                }
                mobileBehavior
                className="payment-tabs__tooltip"
              />
            }
            id={ tab.id }
            className={
              classNames({
                'payment-tabs__tab': true,
                'payment-tabs__tab-active' : selectedTab === index,
                'payment-tabs__tab-inactive': selectedTab !== index
              })
            }
          />
        ))
      }
    </Tabs>
  );
}

export default PaymentTabs;
